import { SVGProps } from 'react'

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 108" {...props}>
    <g id="Chat_Icon" data-name="Chat Icon">
      <g id="Group_8391" data-name="Group 8391" transform="translate(2.363 1.303)">
        <circle
          id="Ellipse_690"
          data-name="Ellipse 690"
          cx="52.5"
          cy="52.5"
          r="52.5"
          transform="translate(-0.363 -0.303)"
          opacity="0.2"
        />
        <g id="Group_8390" data-name="Group 8390" transform="translate(16.693 21.154)">
          <path
            id="Path_8669"
            data-name="Path 8669"
            d="M31.165,73.927V68.321a4.544,4.544,0,0,0,.248-.779,28.45,28.45,0,0,1,7.1-15.4c13.979-15.855,40.5-16.651,55.507-1.7,12.011,11.97,11.875,29.959-.382,41.7a36.6,36.6,0,0,1-25.464,10.307c-11.249.2-22.5.035-33.756.085a3.516,3.516,0,0,1-3.247-1.426V99.436l7.645-8.9c-4.171-5.3-5.811-8.43-6.936-13.234C31.611,76.186,31.4,75.054,31.165,73.927Zm22.418-2.822a4.478,4.478,0,1,0-4.426,4.5A4.512,4.512,0,0,0,53.583,71.106Zm17.941-.043A4.479,4.479,0,1,0,67.14,75.6,4.512,4.512,0,0,0,71.523,71.063Zm13.5-4.419a4.48,4.48,0,1,0,4.441,4.482A4.493,4.493,0,0,0,85.023,66.644Z"
            transform="translate(-31.165 -39.724)"
            fill="currentColor"
          />
        </g>
        <circle
          id="Ellipse_691"
          data-name="Ellipse 691"
          cx="5.421"
          cy="5.421"
          r="5.421"
          transform="translate(29.212 47.152)"
          opacity="0.1"
        />
        <circle
          id="Ellipse_692"
          data-name="Ellipse 692"
          cx="5.421"
          cy="5.421"
          r="5.421"
          transform="translate(47.455 47.152)"
          opacity="0.1"
        />
        <circle
          id="Ellipse_693"
          data-name="Ellipse 693"
          cx="5.421"
          cy="5.421"
          r="5.421"
          transform="translate(65.177 47.152)"
          opacity="0.1"
        />
      </g>
    </g>
  </svg>
)
